package meineglasfaser.frontend.www.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.role
import com.varabyte.kobweb.navigation.Anchor
import meineglasfaser.frontend.common.components.widgets.BootstrapIcon
import meineglasfaser.frontend.common.components.widgets.Details
import meineglasfaser.frontend.common.components.widgets.LiHr
import meineglasfaser.frontend.common.components.widgets.Summary
import meineglasfaser.frontend.www.components.LocalCustomerState
import org.jetbrains.compose.web.dom.B
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul
import org.w3c.dom.HTMLElement

@Composable
fun CustomerAccountPill() {
    val baseInfo = LocalCustomerState.current.accountInfoOrNull()
    var detailsElementRef: HTMLElement? = null

    if (baseInfo != null) {
        Details(attrs = {
            classes("dropdown", "right", "customer-account-pill")
            ref {
                detailsElementRef = it
                onDispose { detailsElementRef = null }
            }
        }) {
            Summary {
                BootstrapIcon("person-fill")
                Text(baseInfo.name)
            }
            Ul {
                Li(attrs = { classes("stack") }) {
                    B { Text(baseInfo.name) }
                    Span { Text(baseInfo.accountEmail) }
                }
                LiHr()
                Li(attrs = { classes("stack") }) {
                    B { Text("Meine Kundennummer") }
                    Span { Text(baseInfo.nid.toString()) }
                }
                LiHr()
                Li(attrs = { classes("stack-with-button") }) {
                    B { Text("Meine Service-PIN") }
                    ServicePinDisplay(baseInfo.accountServicePIN)
                }
                LiHr()
                Li {
                    Anchor(href = "/kundenportal/overview", attrs = {
                        role("button")
                        onClick {
                            detailsElementRef?.removeAttribute("open")
                        }
                    }) {
                        Text("Zum Kundenportal")
                    }
                    Anchor(href = "/kundenportal/auth/logout", attrs = {
                        role("button")
                        classes("outline")
                        onClick {
                            detailsElementRef?.removeAttribute("open")
                        }
                    }) {
                        Text("Abmelden")
                    }
                }
            }
        }
    } else {
        Anchor(href = "/kundenportal/auth/login", attrs = {
            role("button")
        }) {
            BootstrapIcon("person-fill")
            Text("Login")
        }
    }
}

@Composable
fun ServicePinDisplay(servicePin: String) {
    var showServicePIN by remember { mutableStateOf(false) }
    Span { Text(if (showServicePIN) servicePin else "••••") }
    Button(attrs = {
        classes("textual")
        onClick {
            showServicePIN = !showServicePIN
        }
    }) {
        BootstrapIcon(if (showServicePIN) "eye-slash" else "eye")
    }
}
